(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    class CardSwatches extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.card-wrapper');
      if (!this.card) return;

      this.image = this.card.querySelector('.card__media .media > img');
      this.cardLinks = this.card.querySelectorAll('.card__heading a.full-unstyled-link');
      this.swatchLinks = this.querySelectorAll('.card__swatch-link');
      this.original = {
        src: this.image ? this.image.getAttribute('src') : null,
        srcset: this.image ? this.image.getAttribute('srcset') : null,
        href: this.cardLinks.length ? this.cardLinks[0].getAttribute('href') : null,
      };

      const canHover = window.matchMedia('(hover: hover) and (min-width: 990px)').matches;
      if (!canHover) return;

      this.addEventListener('mouseover', (event) => this.onEnter(event));
      this.addEventListener('focusin', (event) => this.onEnter(event));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.reset();
      });
      this.card.addEventListener('mouseleave', () => this.reset());
    }

    onEnter(event) {
      const link = event.target.closest('.card__swatch-link');
      if (link) this.activate(link);
    }

    activate(link) {
      const { variantSrc, variantSrcset } = link.dataset;

      if (this.image && variantSrc) {
        this.image.setAttribute('srcset', variantSrcset || '');
        this.image.setAttribute('src', variantSrc);
        this.card.classList.add('card-wrapper--variant-active');
      } else {
        this.restoreImage();
      }

      this.cardLinks.forEach((cardLink) => cardLink.setAttribute('href', link.getAttribute('href')));
      this.swatchLinks.forEach((swatchLink) => swatchLink.classList.toggle('is-active', swatchLink === link));
    }

    restoreImage() {
      if (!this.image) return;
      if (this.original.srcset !== null) this.image.setAttribute('srcset', this.original.srcset);
      if (this.original.src !== null) this.image.setAttribute('src', this.original.src);
      this.card.classList.remove('card-wrapper--variant-active');
    }

    reset() {
      this.restoreImage();
      if (this.original.href !== null) {
        this.cardLinks.forEach((cardLink) => cardLink.setAttribute('href', this.original.href));
      }
      this.swatchLinks.forEach((swatchLink) => swatchLink.classList.remove('is-active'));
    }
  }

  if (!customElements.get('card-swatches')) {
    customElements.define('card-swatches', CardSwatches);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-subnav"] && !Shopify.designMode) return;
  try {
    class CollectionSubnav extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.collection-subnav__list');
      this.items = [...this.querySelectorAll('.collection-subnav__item:not(.collection-subnav__item--more)')];
      this.moreItem = this.querySelector('.collection-subnav__item--more');
      this.moreButton = this.querySelector('.collection-subnav__more');
      this.desktop = window.matchMedia('(min-width: 750px)');

      // Sibling pages share the chip set, so the row's state (expanded on
      // desktop, scroll position on mobile) is handed to the next page via
      // sessionStorage and the row appears not to move under the user.
      this.stateKey = `collection-subnav:${this.items.map((item) => item.textContent.trim()).join('|')}`;
      const saved = sessionStorage.getItem(this.stateKey);
      sessionStorage.removeItem(this.stateKey);
      this.savedState = saved ? JSON.parse(saved) : null;
      this.expanded = Boolean(this.savedState?.expanded);
      this.classList.toggle('collection-subnav--expanded', this.expanded);
      this.list?.addEventListener('click', (event) => {
        if (!event.target.closest('.collection-subnav__link')) return;
        sessionStorage.setItem(this.stateKey, JSON.stringify({ expanded: this.expanded, scroll: this.list.scrollLeft }));
      });

      this.fit = this.fit.bind(this);
      this.moreButton?.addEventListener('click', () => this.toggle());
      new ResizeObserver(this.fit).observe(this);
      this.desktop.addEventListener('change', this.fit);
      this.fit();
    }

    // Collapsed: show up to data-max-visible chips that fit on one line, the
    // rest hidden behind "more". A tail of one or two extra chips is shown
    // anyway, since hiding so few behind a control is not worth the click.
    // Order never changes: if the active chip would end up hidden, the row
    // simply starts expanded. Measurement happens with everything visible
    // so the widths are real.
    fit() {
      if (!this.list || !this.moreItem) return;
      this.items.forEach((item) => item.classList.remove('collection-subnav__item--overflow'));
      this.moreItem.hidden = true;

      if (!this.desktop.matches) {
        this.revealActive();
        return;
      }

      const limit = this.list.clientWidth;
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      const maxVisible = parseInt(this.dataset.maxVisible, 10) || Infinity;
      const tolerance = 2;
      const last = this.items[this.items.length - 1];
      const fitsAll = !last || last.offsetLeft + last.offsetWidth <= limit;
      if (fitsAll && this.items.length <= maxVisible + tolerance) return;
      if (this.expanded) {
        this.moreItem.hidden = true;
        return;
      }

      this.moreItem.hidden = false;
      const moreWidth = this.moreItem.offsetWidth + gap;
      const hide = [];
      for (let i = this.items.length - 1; i >= 0; i -= 1) {
        const item = this.items[i];
        if (i < maxVisible && item.offsetLeft + item.offsetWidth + moreWidth <= limit) break;
        hide.push(item);
      }

      if (hide.some((item) => item.querySelector('.collection-subnav__link--active'))) {
        this.toggle();
        return;
      }
      hide.forEach((item) => item.classList.add('collection-subnav__item--overflow'));
    }

    // Mobile: the row scrolls. Sibling pages share the same chip set, so the
    // scroll position saved when a chip was tapped is restored on the next
    // page and the row appears to stay put with the new chip now active.
    // Without a saved position (deep link), the active chip is aligned to
    // the left gutter.
    revealActive() {
      if (this.restored) return;
      this.restored = true;

      if (this.savedState?.scroll) this.list.scrollLeft = this.savedState.scroll;

      const active = this.querySelector('.collection-subnav__link--active');
      if (!active) return;
      const a = active.getBoundingClientRect();
      const l = this.list.getBoundingClientRect();
      const gutter = parseFloat(getComputedStyle(this.list).paddingLeft) || 0;
      if (a.right > l.right || a.left < l.left + gutter) {
        this.list.scrollLeft += a.left - l.left - gutter;
      }
    }

    // One-way: once opened the row stays open and the link goes away, like
    // a "read more". A reload returns to the collapsed state.
    toggle() {
      const firstHidden = this.items.find((item) => item.classList.contains('collection-subnav__item--overflow'));
      this.expanded = true;
      this.classList.add('collection-subnav--expanded');
      this.moreButton.setAttribute('aria-expanded', 'true');
      this.fit();
      // The link disappears once opened, so hand focus to the first chip it
      // revealed instead of dropping it on <body>.
      if (document.activeElement === this.moreButton) {
        firstHidden?.querySelector('.collection-subnav__link')?.focus({ preventScroll: true });
      }
    }
  }

  if (!customElements.get('collection-subnav')) customElements.define('collection-subnav', CollectionSubnav);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["day-night-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('day-night-toggle')) {
    customElements.define(
      'day-night-toggle',
      class DayNightToggle extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.gallery = this.closest('media-gallery');
          this.button.addEventListener('click', this.toggle);

          // Variant changes swap the variant slide in place; carry the
          // current state over to whichever night slide arrives.
          this.observer = new MutationObserver(this.sync);
          const track = this.gallery?.querySelector('[data-embla-main] ul');
          if (track) this.observer.observe(track, { childList: true });
        }

        disconnectedCallback() {
          this.button.removeEventListener('click', this.toggle);
          this.observer?.disconnect();
          this.audio?.close();
        }

        get isNight() {
          return this.button.getAttribute('aria-checked') === 'true';
        }

        toggle = () => {
          this.button.setAttribute('aria-checked', String(!this.isNight));
          this.sync();
          this.click(this.isNight);
        };

        /**
         * Synthesises a soft wall-switch click: a short burst of filtered
         * noise with a fast decay. Switching on sounds a touch brighter than
         * switching off. Built on first use, since browsers only allow audio
         * to start from a user gesture.
         * @param {boolean} on
         */
        click(on) {
          const AudioContext = window.AudioContext || window.webkitAudioContext;
          if (!AudioContext) return;
          this.audio ??= new AudioContext();
          const ctx = this.audio;
          if (ctx.state === 'suspended') ctx.resume();

          const duration = 0.05;
          const buffer = ctx.createBuffer(1, Math.ceil(ctx.sampleRate * duration), ctx.sampleRate);
          const data = buffer.getChannelData(0);
          for (let i = 0; i < data.length; i++) {
            data[i] = (Math.random() * 2 - 1) * Math.exp(-i / (ctx.sampleRate * 0.004));
          }

          const noise = ctx.createBufferSource();
          noise.buffer = buffer;

          const filter = ctx.createBiquadFilter();
          filter.type = 'bandpass';
          filter.frequency.value = on ? 3200 : 2200;
          filter.Q.value = 1.2;

          const gain = ctx.createGain();
          gain.gain.value = 0.35;

          noise.connect(filter).connect(gain).connect(ctx.destination);
          noise.start();
        }

        sync = () => {
          this.gallery?.querySelectorAll('[data-night-slide]').forEach((slide) => {
            slide.classList.toggle('is-night', this.isNight);
          });
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fabric-pins"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fabric-pin')) {
    customElements.define(
      'fabric-pin',
      class FabricPin extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector('.fabric-pin__trigger');
          this.view = this.querySelector('.fabric-pin__view');
          this.frame = this.closest('.product-media-container') || this.parentElement;
          this.gallery = this.closest('media-gallery');

          this.onTrigger = (event) => {
            event.stopPropagation();
            // detail is 0 for keyboard activation; only then move focus into the view.
            this.open(event.detail === 0);
          };
          this.onView = (event) => {
            event.stopPropagation();
            const switcher = event.target.closest('.fabric-pin__switch');
            if (switcher) return this.show(switcher.dataset.fabricIndex);
            if (event.target.closest('.fabric-pin__caption')) return;
            this.close();
          };
          this.onDocumentClick = (event) => {
            if (!this.contains(event.target)) this.close(true);
          };
          this.onKeydown = (event) => {
            if (event.key === 'Escape' && this.isOpen) this.close();
          };
          this.onResize = () => {
            if (this.isOpen) this.fit();
          };

          this.trigger.addEventListener('click', this.onTrigger);
          this.view.addEventListener('click', this.onView);
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeydown);
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.frame);

          // Warm the large fabric image so the view never opens blank.
          this.onWarm = () => {
            this.view.querySelectorAll('.fabric-pin__image').forEach((image) => {
              const url = image.style.backgroundImage.slice(5, -2);
              if (url) new Image().src = url;
            });
          };
          this.trigger.addEventListener('pointerenter', this.onWarm, { once: true });
          this.trigger.addEventListener('focus', this.onWarm, { once: true });
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeydown);
          this.resizeObserver?.disconnect();
          this.gallery?.classList.remove('has-fabric-view');
        }

        get isOpen() {
          return !this.view.hidden;
        }

        open(moveFocus) {
          this.onWarm();
          this.trigger.setAttribute('aria-expanded', 'true');
          this.gallery?.classList.add('has-fabric-view');
          this.view.hidden = false;
          this.fit();
          requestAnimationFrame(() => this.classList.add('is-open'));
          if (moveFocus) this.view.querySelector('.fabric-pin__close').focus({ preventScroll: true });
        }

        close(instant = false) {
          if (!this.isOpen) return;
          const returnFocus = this.view.contains(document.activeElement);
          this.classList.remove('is-open');
          this.trigger.setAttribute('aria-expanded', 'false');
          this.gallery?.classList.remove('has-fabric-view');
          const hide = () => {
            if (!this.classList.contains('is-open')) this.view.hidden = true;
          };
          if (instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            hide();
          } else {
            setTimeout(hide, 260);
          }
          if (returnFocus) this.trigger.focus({ preventScroll: true });
        }

        show(index) {
          this.view.querySelectorAll('[data-fabric-index]').forEach((element) => {
            const active = element.dataset.fabricIndex === index;
            if (element.classList.contains('fabric-pin__switch')) {
              element.setAttribute('aria-pressed', active);
            } else {
              element.hidden = !active;
            }
          });
        }

        // Size the view to the media frame; it is positioned relative to
        // this pin-sized element.
        fit() {
          const frame = this.frame.getBoundingClientRect();
          const host = this.getBoundingClientRect();
          Object.assign(this.view.style, {
            left: `${Math.round(frame.left - host.left)}px`,
            top: `${Math.round(frame.top - host.top)}px`,
            width: `${Math.round(frame.width)}px`,
            height: `${Math.round(frame.height)}px`,
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-chat-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('header-chat-button')) {
    customElements.define(
      'header-chat-button',
      class HeaderChatButton extends HTMLElement {
        connectedCallback() {
          this.querySelector('button').addEventListener('click', () => {
            const chat = document.querySelector('shopify-chat');
            if (!chat) return;
            if (chat.open) chat.close();
            else chat.show();
          });

          // The Inbox app embed defines and inserts <shopify-chat> after load.
          customElements.whenDefined('shopify-chat').then(() => {
            const chat = document.querySelector('shopify-chat');
            this.hidden = !chat;
            if (chat?.shadowRoot) this.#watchUnread(chat.shadowRoot);
          });
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        /**
         * Mirror the unread-replies dot of Inbox's own launcher, which lives in
         * nested shadow roots that a single MutationObserver cannot see into.
         * @param {ShadowRoot} chatRoot
         */
        #watchUnread(chatRoot) {
          const observed = new WeakSet();
          const update = () => {
            const roots = [chatRoot];
            let indicator = null;
            for (let i = 0; i < roots.length; i++) {
              const root = roots[i];
              if (!observed.has(root)) {
                observed.add(root);
                this.observer.observe(root, {
                  subtree: true,
                  childList: true,
                  attributes: true,
                  attributeFilter: ['class'],
                });
              }
              indicator ??= root.querySelector('.activator__indicator');
              for (const el of root.querySelectorAll('*')) if (el.shadowRoot) roots.push(el.shadowRoot);
            }
            this.classList.toggle(
              'header-chat-button--unread',
              !!indicator?.classList.contains('activator__indicator--active')
            );
          };

          this.observer = new MutationObserver(update);
          update();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-price-note"] && !Shopify.designMode) return;
  try {
    /**
   * Opens the price note's drawer from its info button and closes it from the
   * close button, the backdrop or Escape, sliding out the way it arrived
   * unless the visitor prefers reduced motion.
   */
  class PriceNote extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('dialog');
      if (!this.drawer) return;

      this.addEventListener('click', this.onClick);
      // `cancel` and `close` do not bubble, so they are bound on the dialog.
      this.drawer.addEventListener('cancel', this.onCancel);
      this.drawer.addEventListener('close', this.onClose);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.drawer?.removeEventListener('cancel', this.onCancel);
      this.drawer?.removeEventListener('close', this.onClose);
      document.body.classList.remove('overflow-hidden');
    }

    onClick = (event) => {
      if (event.target.closest('[data-price-note-open]')) {
        if (this.drawer.open) return;
        this.drawer.classList.remove('is-closing');
        this.drawer.showModal();
        document.body.classList.add('overflow-hidden');
        return;
      }

      // A backdrop click reports the dialog itself as the target.
      if (event.target.closest('[data-price-note-close]') || event.target === this.drawer) this.closeDrawer();
    };

    onCancel = (event) => {
      event.preventDefault();
      this.closeDrawer();
    };

    onClose = () => {
      document.body.classList.remove('overflow-hidden');
    };

    closeDrawer() {
      const drawer = this.drawer;
      if (!drawer.open || drawer.classList.contains('is-closing')) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        drawer.close();
        return;
      }

      drawer.classList.add('is-closing');
      drawer.addEventListener(
        'animationend',
        () => {
          drawer.classList.remove('is-closing');
          drawer.close();
        },
        { once: true }
      );
    }
  }

  if (!customElements.get('price-note')) customElements.define('price-note', PriceNote);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-trust-row"] && !Shopify.designMode) return;
  try {
    /**
   * Opens a trust row's drawer from the row itself and closes it from the
   * close button, the backdrop or Escape. Closing is delayed by one
   * slide-out animation so the panel leaves the way it arrived; with reduced
   * motion the dialog closes immediately.
   */
  class ProductTrustRow extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onCancel = this.onCancel.bind(this);
      this.onClose = this.onClose.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      // `cancel` (Escape) and `close` do not bubble, so they are bound on
      // each dialog rather than delegated from the host.
      for (const drawer of this.drawers) {
        drawer.addEventListener('cancel', this.onCancel);
        drawer.addEventListener('close', this.onClose);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      for (const drawer of this.drawers) {
        drawer.removeEventListener('cancel', this.onCancel);
        drawer.removeEventListener('close', this.onClose);
      }
      document.body.classList.remove('overflow-hidden');
    }

    get drawers() {
      return this.querySelectorAll('[data-trust-drawer]');
    }

    openDrawer(index) {
      const drawer = this.querySelector(`[data-trust-drawer="${index}"]`);
      if (!drawer || drawer.open) return;
      drawer.classList.remove('is-closing');
      drawer.showModal();
      document.body.classList.add('overflow-hidden');
    }

    onKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const row = event.target.closest('[data-trust-row]');
      if (!row || event.target !== row) return;
      event.preventDefault();
      this.openDrawer(row.dataset.trustRow);
    }

    onClick(event) {
      const closer = event.target.closest('[data-trust-drawer-close]');
      if (closer) {
        this.closeDrawer(closer.closest('dialog'));
        return;
      }

      // A backdrop click reports the dialog itself as the target; clicks on
      // the panel's content report one of its descendants.
      const drawer = event.target.closest('dialog');
      if (drawer) {
        if (event.target === drawer) this.closeDrawer(drawer);
        return;
      }

      const row = event.target.closest('[data-trust-row]');
      if (row) this.openDrawer(row.dataset.trustRow);
    }

    onCancel(event) {
      event.preventDefault();
      this.closeDrawer(event.currentTarget);
    }

    onClose() {
      document.body.classList.remove('overflow-hidden');
    }

    closeDrawer(drawer) {
      if (!drawer || !drawer.open || drawer.classList.contains('is-closing')) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        drawer.close();
        return;
      }

      drawer.classList.add('is-closing');
      drawer.addEventListener(
        'animationend',
        () => {
          drawer.classList.remove('is-closing');
          drawer.close();
        },
        { once: true }
      );
    }
  }

  if (!customElements.get('product-trust-row')) {
    customElements.define('product-trust-row', ProductTrustRow);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker-bundle"] && !Shopify.designMode) return;
  try {
    // Hovering an option chip previews its name in the head readout and its
  // variant image in the header thumb; leaving restores the checked value.
  // Delegated on the document because `variant-selects` is replaced on
  // every variant change.
  (() => {
    const hitFor = (target) => {
      const label = target.closest?.('.bundle-option__values label');
      if (!label) return null;
      return { label, fieldset: label.closest('.bundle-option') };
    };

    // The server-rendered src is kept as the fallback for values whose
    // variant carries no image of its own.
    const swapThumb = (fieldset, label) => {
      const img = fieldset?.querySelector('.bundle-group__thumb img');
      if (!img) return;
      if (!img.dataset.baseSrc) {
        img.dataset.baseSrc = img.getAttribute('src') || '';
        img.dataset.baseSrcset = img.getAttribute('srcset') || '';
      }
      const src = label?.dataset.thumbSrc || img.dataset.baseSrc;
      if (!src) return;
      img.src = src;
      img.srcset = label?.dataset.thumbSrcset || img.dataset.baseSrcset;
    };

    document.addEventListener('mouseover', (event) => {
      const hit = hitFor(event.target);
      if (!hit) return;
      const input = document.getElementById(hit.label.htmlFor);
      const readout = hit.fieldset?.querySelector('[data-selected-value]');
      if (input && readout) readout.textContent = input.value;
      swapThumb(hit.fieldset, hit.label);
    });

    document.addEventListener('mouseout', (event) => {
      const hit = hitFor(event.target);
      if (!hit) return;
      const checked = hit.fieldset?.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      const readout = hit.fieldset.querySelector('[data-selected-value]');
      if (readout) readout.textContent = checked.value;
      swapThumb(hit.fieldset, hit.fieldset.querySelector(`label[for="${CSS.escape(checked.id)}"]`));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    // Inline swatch rows preview the hovered value in the "Renk: ..." label and
  // fall back to the checked value when the pointer leaves the swatches. The
  // swap is instant on purpose: pointers sweep across swatches quickly.
  (() => {
    function show(swatches, value) {
      const target = swatches.closest('.variant-box--inline')?.querySelector('[data-selected-value]');
      if (target && value) target.textContent = value;
    }

    document.addEventListener('pointerover', (event) => {
      const label = event.target.closest?.('.variant-box--inline .variant-box__swatches label');
      if (label) show(label.parentElement, label.previousElementSibling?.value);
    });

    document.addEventListener('pointerout', (event) => {
      const swatches = event.target.closest?.('.variant-box--inline .variant-box__swatches');
      if (!swatches || swatches.contains(event.relatedTarget)) return;
      show(swatches, swatches.querySelector('input:checked')?.value);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["truncated-content"] && !Shopify.designMode) return;
  try {
    class TruncatedContent extends HTMLElement {
    constructor() {
      super();
      this.body = this.querySelector('.truncated-content__body');
      this.toggle = this.querySelector('.truncated-content__toggle');
      this.expanded = false;
      this.onToggle = this.onToggle.bind(this);
      this.onTransitionEnd = this.onTransitionEnd.bind(this);
    }

    connectedCallback() {
      if (!this.body || !this.toggle) return;
      this.toggle.addEventListener('click', this.onToggle);
      this.body.addEventListener('transitionend', this.onTransitionEnd);
      this.measure();
      // Fonts and images settle after first paint; re-check so a short
      // description that later grows (or vice versa) gets the right state.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.measure());
      }
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.toggle.removeEventListener('click', this.onToggle);
      this.body.removeEventListener('transitionend', this.onTransitionEnd);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    get collapsedHeight() {
      const value = getComputedStyle(this).getPropertyValue('--truncate-height').trim();
      const rem = parseFloat(value) || 20;
      const rootSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      return rem * rootSize;
    }

    measure() {
      if (this.expanded || this.classList.contains('is-animating')) return;
      // Only clamp when a meaningful amount of text would be hidden; a
      // couple of extra lines are not worth a toggle.
      const overflow = this.body.scrollHeight - this.collapsedHeight;
      const needsClamp = overflow > 48;
      this.classList.toggle('is-collapsed', needsClamp);
      this.toggle.hidden = !needsClamp;
    }

    onToggle() {
      this.expanded ? this.collapse() : this.expand();
    }

    expand() {
      const from = this.body.getBoundingClientRect().height;
      this.expanded = true;
      this.classList.remove('is-collapsed');
      const to = this.body.scrollHeight;
      this.animateHeight(from, to);
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    collapse() {
      const from = this.body.getBoundingClientRect().height;
      this.expanded = false;
      const to = this.collapsedHeight;
      this.animateHeight(from, to, () => this.classList.add('is-collapsed'));
      this.toggle.setAttribute('aria-expanded', 'false');
      this.scrollBackIntoView();
    }

    animateHeight(from, to, done) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        if (done) done();
        return;
      }
      this.afterAnimation = done;
      this.classList.add('is-animating');
      this.body.style.maxHeight = `${from}px`;
      // Force a layout so the transition starts from the measured height.
      void this.body.offsetHeight;
      this.body.style.maxHeight = `${to}px`;
    }

    onTransitionEnd(event) {
      if (event.target !== this.body || event.propertyName !== 'max-height') return;
      this.classList.remove('is-animating');
      this.body.style.maxHeight = '';
      if (this.afterAnimation) {
        this.afterAnimation();
        this.afterAnimation = null;
      }
    }

    scrollBackIntoView() {
      // Collapsing pulls the page up under the reader; bring the start of
      // the text back into view so they are not left mid-page.
      const top = this.getBoundingClientRect().top;
      if (top >= 0) return;
      const header = document.querySelector('.section-header');
      const offset = header ? header.getBoundingClientRect().height + 16 : 16;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollBy({ top: top - offset, behavior: reduce ? 'auto' : 'smooth' });
    }
  }

  customElements.define('truncated-content', TruncatedContent);
  } catch(e) { console.error(e); }
})();

})();
